module.exports = __webpack_public_path__ + "img/9.a093b7d4.jpg";